import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
import { sysFileUpload } from "@/api/managementCenter/otherApi";
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver"; // 编辑器插件plugins
// 更多插件参考：https://www.tiny.cloud/docs/plugins/

import "tinymce/plugins/image"; // 插入上传图片插件

import "tinymce/plugins/media"; // 插入视频插件

import "tinymce/plugins/table"; // 插入表格插件

import "tinymce/plugins/lists"; // 列表插件

import "tinymce/plugins/wordcount"; // 字数统计插件

import "tinymce/icons/default";
export default {
  components: {
    Editor: Editor
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    height: {
      type: Number,
      default: 400
    },
    // 基本路径，默认为空根目录，如果你的项目发布后的地址为目录形式，
    disabled: {
      type: Boolean,
      default: false
    },
    plugins: {
      type: [String, Array],
      default: "lists image media table wordcount"
    },
    toolbar: {
      type: [String, Array],
      default: "bold italic forecolor backcolor fontsizeselect | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image table"
    }
  },
  data: function data() {
    var _this = this;

    return {
      init: {
        language_url: "".concat(process.env.BASE_URL, "tinymces/langs/zh_CN.js"),
        language: "zh_CN",
        skin_url: "".concat(process.env.BASE_URL, "tinymces/skins/ui/oxide"),
        content_css: "".concat(process.env.BASE_URL, "tinymces/skins/content/default/content.css"),
        height: this.height,
        fontsize_formats: "12px 13px 14px 15px 16px 17px 18px 20px 22px 24px 26px 30px 35px 40px 50px",
        plugins: this.plugins,
        toolbar: this.toolbar,
        branding: false,
        menubar: false,
        // 此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
        // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
        images_upload_handler: function images_upload_handler(blobInfo, success, failure) {
          var fd = new FormData();
          fd.append("fromTarget", 0);
          fd.append("file", blobInfo.blob());
          sysFileUpload(fd).then(function (_ref) {
            var data = _ref.data;

            if (data.code == 0) {
              success(data.data.url);
            } else {
              _this.$message.warning(data.msg || "上传图片失败!");
            }
          }).catch(function (err) {
            _this.$message.error("上传图片异常!");
          });
        }
      },
      myValue: this.value
    };
  },
  mounted: function mounted() {
    tinymce.init({});
  },
  methods: {
    // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
    // 需要什么事件可以自己增加
    onClick: function onClick(e) {
      this.$emit("onClick", e, tinymce);
    },
    // 可以添加一些自己的自定义事件，如清空内容
    clear: function clear() {
      this.myValue = "";
    }
  },
  watch: {
    value: function value(newValue) {
      this.myValue = newValue || "";
    },
    myValue: function myValue(newValue) {
      this.$emit("input", newValue);
    }
  }
};